import { useSyncExternalStore } from 'react';
import { getAreGlobalHotkeysEnabled, subscribeToGlobalHotkeys } from './globalHotkeysStore';

/** Whether anything is currently suppressing app-level hotkeys. */
export function useAreGlobalHotkeysEnabled(): boolean {
  return useSyncExternalStore(subscribeToGlobalHotkeys, getAreGlobalHotkeysEnabled);
}
